import React, { useEffect, useState, useMemo } from "react";
import moment from "moment";
import styles from "./otp.module.scss";
export const ResendTimmer = ({ onComplete }: { onComplete: () => void }) => {
  const [time, setTime] = useState(0);
  const [startTime, setStartTime] = useState<any>(moment());
  let slot_time = 120;
  let currentTime = moment();

  useEffect(() => {
    const interval = setInterval(() => {
      if (time < slot_time) {
        setTime(time + 1);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [time]);

  const { remaining, progress } = useMemo(() => {
    if (!startTime) {
      return { remaining: "00:00", progress: 0 };
    }
    let differenceInSeconds = currentTime.diff(startTime - 1, "seconds");
    let remainingTime = moment.duration(
      slot_time - differenceInSeconds,
      "seconds"
    );

    let progress = ((slot_time - differenceInSeconds) * 100) / slot_time;

    const minutes = remainingTime.minutes().toString().padStart(2, "0");
    const seconds = remainingTime.seconds().toString().padStart(2, "0");
    if (Number(seconds) <= 0 && Number(minutes) <= 0) {
      onComplete && onComplete();
      return { remaining: "00:00", progress: 0 };
    }
    return { remaining: `${minutes}:${seconds}`, progress: progress };
  }, [currentTime, startTime, onComplete]);

  return (
    <span className={styles["timer-text"]}>Resend code in {remaining}</span>
  );
};
